const USER_ID = `user_f6ZSyOCXOQZRAS4i48WCY` //userID
const TEMPLATE_ID = `template_zx264gq`    //templateID
const  SERVICE_ID = `service_xzawnfw`

export {USER_ID, TEMPLATE_ID, SERVICE_ID}
